import { ApplicationConfig, provideZoneChangeDetection, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';

import { routes } from './app.routes';
import { unknownUserInterceptor } from './core/interceptors/unknown-user.interceptor';

// Registrar los datos de localización para Argentina
registerLocaleData(localeEsAr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(withInterceptors([unknownUserInterceptor])),
    { provide: LOCALE_ID, useValue: 'es-AR' }  // ← ESTA ES LA LINEA PARA CONFIGURAR EN ARGENTINA
  ]
};